import { FsTournamentTrack } from "db/model/tournament/FsTournamentTrack";
import { TournamentTrack } from "model/Tournament/TournamentTrack";

export const mapTournamentTrack = (
  fsModel: FsTournamentTrack
): TournamentTrack | undefined => {
  if (!fsModel.id) {
    return undefined;
  }

  return {
    id: fsModel.id,
    name: fsModel.name ?? "???",
  };
};
